const resources = {
    footerLabel: 'Customer Service Chat',
    pageLabel: 'Customer Service',
    buttonLabel: 'Customer Service'
};

export default function getResource(label) {
    return resources[label];
}
